import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {SysConfigService} from './sys-config.service';
import {ProvinceDTO} from '../dto/province.model';
import {EmployeeDesignationDTO} from '../dto/employee-designation.model';
import {AppConfig} from '../common/app.config';

@Injectable({
  providedIn: 'root'
})
export class ProvinceService {
  provinceSearchDetailsChange = new EventEmitter<ProvinceDTO[]>();
  private provinceSearchDetailsItem: ProvinceDTO[] = [];

  public BASE_URL = this.appConfig.getConfig('BASE_URL') + 'api/';

  private headers = new HttpHeaders({
    'Content-Type': 'application/json; charset=utf-8'
  });


  constructor(private httpClient: HttpClient, private appConfig: AppConfig) {
  }

  /** Save Province Details **/
  saveProvince(provinceDTO: ProvinceDTO) {
    return this.httpClient.post(this.BASE_URL + 'province/save' , provinceDTO,{responseType: 'text'});
  }

  /** Get all province details **/
  getAllProvinces() {
    return this.httpClient.get(this.BASE_URL + 'province/all');
  }

  /** Search province details **/
  searchProvince(provinceDTO: ProvinceDTO) {
    return this.httpClient.post(this.BASE_URL + 'province/search', provinceDTO, { headers: this.headers });
  }

  /** Delete province details **/
  deleteProvinceDetails(code: string){
    return this.httpClient.delete(this.BASE_URL + 'province/delete/'+code, { headers: this.headers });
  }

  /** reset searched details **/
  clearProvinceSearchDetails() {
    this.provinceSearchDetailsItem = [];
    this.provinceSearchDetailsChange.emit(this.provinceSearchDetailsItem);
  }

  /** set search details in the table **/
  setProvinceSearchDetails(provinceDetails: ProvinceDTO[]) {
    this.provinceSearchDetailsItem = provinceDetails;
    this.provinceSearchDetailsChange.emit(this.provinceSearchDetailsItem);
  }
}
